import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getChats } from "../store/chats/thunks";
import { selectChatsState } from "../store/chats/selectors";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getChatMembers } from "../pages/Chats/ChatView/helper";

export const useChats = (fetch = false) => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chats, loading, selectedChatId, newMessageCount } =
    useSelector(selectChatsState);

  useEffect(() => {
    if (!Object.keys(chats).length && fetch) {
      dispatch(getChats());
    }
  }, [chats, dispatch, fetch]);

  const { chats: finalChats } = useMemo(() => {
    return {
      chats: Object.values(chats || {})
        ?.filter(({ tenant_id }) => selectedTenantId === tenant_id)
        ?.map((c) => ({ ...c, users: getChatMembers(c) }))
        ?.sort((a, b) => {
          const dateA = new Date(
            a?.last_message?.sent_at || a?.created_at,
          ).getTime();
          const dateB = new Date(
            b?.last_message?.sent_at || b?.created_at,
          ).getTime();

          return dateB - dateA;
        }),
    };
  }, [chats, selectedTenantId]);

  const selectedChat = useMemo(() => {
    return chats?.[selectedChatId];
  }, [chats, selectedChatId]);

  return {
    chats: finalChats,
    loading,
    selectedChat,
    selectedChatId,
    newMessageCount,
    selectedTenantId,
  };
};
